import PropTypes from 'prop-types'
import { Stack, Text } from '@leroy-merlin-br/backyard-react-ui'

import { Collapse, CollapseTitle } from 'reactSite/Collapse'
import { Timeline } from 'reactSite/MyOrders/components/Timeline'
import ShipmentContent from 'reactSite/MyOrders/components/Shipment/Content'
import PaymentInfo from 'reactSite/MyOrders/components/Payment/Info'
import { ServiceContent } from 'reactSite/MyOrders/components/Service'

import { Notification } from 'checkout/components/Notification'

const OrderContent = ({
  discount,
  isOpen,
  payable,
  payments,
  phone,
  shipments,
  shippingCost,
  steps,
  totalValue,
  services,
  hasOrderToPickUp = false
}) => {
  const hasServices = services && services.items.length > 0

  const hasSteps = steps && Object.entries(steps) > 0

  const hasShipments = shipments && shipments.length > 0

  const storeName = hasShipments && shipments.reduce((accumulator, shipment) => {
    if (shipment.type === 'Clique e retire') {
      accumulator = shipment.shippingAddress.storeName
    }

    return accumulator
  }, '')

  return (
    <Stack spacing="kilo">
      { (hasOrderToPickUp && storeName) &&
        <Notification type="warning">
          <Text noMargin>
            Seu pedido já está <Text as="strong" bold noMargin>disponível para retirada</Text> na loja <Text as="strong" bold noMargin>{ storeName }</Text>
          </Text>
        </Notification>
      }
      { hasSteps && <Timeline steps={steps} /> }
      {
        hasShipments &&
          shipments.map((shipment, index) => (
            <Collapse
              className="order-content"
              key={index}
              isOpen={isOpen}
              title={<CollapseTitle {...shipment} quantity={shipment.items.length} />}
              content={<ShipmentContent {...shipment} phone={phone} />}
            />
          ))
      }
      {
        hasServices &&
          services.items.map((service, index) => (
            <Collapse
              className="order-content"
              key={index}
              isOpen={false}
              title={<CollapseTitle {...service} type="Serviços" />}
              content={<ServiceContent {...service} address={services.installationAddress} />}
            />
          ))
      }

      <PaymentInfo
        payable={payable}
        payments={payments}
        totalValue={totalValue}
        shippingCost={shippingCost}
        discount={discount} />
    </Stack>
  )
}

OrderContent.propTypes = {
  date: PropTypes.string,
  totalValue: PropTypes.object,
  discount: PropTypes.object,
  shippingCost: PropTypes.object,
  shipments: PropTypes.array,
  payments: PropTypes.array,
  steps: PropTypes.array
}

export default OrderContent
